import { TSchemaBuilder } from "@pages/ManualDocumentV2/core";
import * as Yup from "yup";
import {
  customerSchema,
  documentInfoSchema,
  itemsSchema,
  taxesSchema,
  totalsSchema,
  uploadSchema,
  vendorSchema,
} from "../../_shared/schemaHelpers";

export const deliveryNoteSchema: TSchemaBuilder = (t) =>
  documentInfoSchema({
    t,
    documentClass: "DeliveryNote",
    poErrorKey: "poNumber_is_required",
    dueDateRequired: false,
    enforceDateOrder: false,
  })
    .concat(
      Yup.object({
        documentNumber: Yup.string().required(t("documentNumber_is_required")),
      }),
    )
    .concat(customerSchema(t, { optional: ["customerCountry"] }))
    .concat(
      Yup.object({
        customerCompanyAddress: Yup.string().required(
          t("customerCompanyAddress_is_required"),
        ),
      }),
    )
    .concat(vendorSchema(t, { optional: ["vendorCountry"] }))
    .concat(
      Yup.object({
        vendorCompanyAddress: Yup.string()
          .required(t("vendorCompanyAddress_is_required"))
          .typeError(t("vendorCompanyAddress_is_required")),
      }),
    )
    .concat(itemsSchema(t))
    .concat(taxesSchema(t))
    .concat(totalsSchema(t))
    .concat(uploadSchema()) as Yup.ObjectSchema<any>;
